// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Project_heading {
  text-align: center;
  margin-top: 10px;
}

.projectCardData-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
  padding: 20px;
  background-color: #f5f5f5;
  box-sizing: border-box;
}

.projectCardData-card {
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  transition: transform 0.2s ease-in-out;
  box-sizing: border-box;
}

.projectCardData-card:hover {
  transform: translateY(-5px);
}

.projectCardData-title {
  font-size: 18px;
  color: #333333;
  margin-bottom: 10px;
}

.projectCardData-card p {
  margin: 5px 0;
  font-size: 14px;
  color: #555555;
  line-height: 1.5;
}

.projectCardData-empty {
  font-size: 16px;
  color: #888;
  text-align: center;
  width: 100%;
}
.project_add_task_button {
  margin-left: 5px;
  height: 35px;
  width: 100px;
  border: none;
  border-radius: 5px;
  background-color: #02337b;
  color: white;
}
@media (max-width: 768px) {
  .projectCardData-card {
    padding: 16px;
  }

  .projectCardData-title {
    font-size: 16px;
  }

  .projectCardData-card p {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .projectCardData-container {
    padding: 10px;
    gap: 12px;
  }

  .projectCardData-card {
    padding: 14px;
  }

  .projectCardData-title {
    font-size: 15px;
  }

  .projectCardData-card p {
    font-size: 12.5px;
  }
}
/* *****task form */

.project_task_from_overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.project_task_from_popup {
  background: #fff;
  border-radius: 10px;
  padding: 30px 20px;
  width: 100%;
  max-width: 500px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
  position: relative;
  box-sizing: border-box;
}

.project_task_from_close {
  position: absolute;
  top: 10px;
  right: 15px;
  background: none;
  border: none;
  font-size: 24px;
  color: #333;
  cursor: pointer;
}

.project_task_from_input {
  width: 100%;
  padding: 10px 12px;
  margin: 8px 0 16px 0;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
  box-sizing: border-box;
}

.project_task_from_label {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-top: 8px;
  display: block;
}

.project_task_from_submit_button {
  background-color: #007bff;
  color: white;
  padding: 10px 14px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  width: 100%;
}

.project_task_from_submit_button:hover {
  background-color: #0056b3;
}

@media (max-width: 768px) {
  .project_task_from_popup {
    width: 90%;
    padding: 20px;
  }

  .project_task_from_input {
    font-size: 13px;
  }

  .project_task_from_submit_button {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .project_task_from_popup {
    padding: 15px;
  }

  .project_task_from_input {
    padding: 8px;
    font-size: 12.5px;
  }

  .project_task_from_label {
    font-size: 13px;
  }

  .project_task_from_submit_button {
    font-size: 13px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Project/project.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;AACA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;AACA,mBAAmB;;AAEnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,uCAAuC;EACvC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".Project_heading {\n  text-align: center;\n  margin-top: 10px;\n}\n\n.projectCardData-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 16px;\n  padding: 20px;\n  background-color: #f5f5f5;\n  box-sizing: border-box;\n}\n\n.projectCardData-card {\n  background-color: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  transition: transform 0.2s ease-in-out;\n  box-sizing: border-box;\n}\n\n.projectCardData-card:hover {\n  transform: translateY(-5px);\n}\n\n.projectCardData-title {\n  font-size: 18px;\n  color: #333333;\n  margin-bottom: 10px;\n}\n\n.projectCardData-card p {\n  margin: 5px 0;\n  font-size: 14px;\n  color: #555555;\n  line-height: 1.5;\n}\n\n.projectCardData-empty {\n  font-size: 16px;\n  color: #888;\n  text-align: center;\n  width: 100%;\n}\n.project_add_task_button {\n  margin-left: 5px;\n  height: 35px;\n  width: 100px;\n  border: none;\n  border-radius: 5px;\n  background-color: #02337b;\n  color: white;\n}\n@media (max-width: 768px) {\n  .projectCardData-card {\n    padding: 16px;\n  }\n\n  .projectCardData-title {\n    font-size: 16px;\n  }\n\n  .projectCardData-card p {\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 480px) {\n  .projectCardData-container {\n    padding: 10px;\n    gap: 12px;\n  }\n\n  .projectCardData-card {\n    padding: 14px;\n  }\n\n  .projectCardData-title {\n    font-size: 15px;\n  }\n\n  .projectCardData-card p {\n    font-size: 12.5px;\n  }\n}\n/* *****task form */\n\n.project_task_from_overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.project_task_from_popup {\n  background: #fff;\n  border-radius: 10px;\n  padding: 30px 20px;\n  width: 100%;\n  max-width: 500px;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);\n  position: relative;\n  box-sizing: border-box;\n}\n\n.project_task_from_close {\n  position: absolute;\n  top: 10px;\n  right: 15px;\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: #333;\n  cursor: pointer;\n}\n\n.project_task_from_input {\n  width: 100%;\n  padding: 10px 12px;\n  margin: 8px 0 16px 0;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  font-size: 14px;\n  box-sizing: border-box;\n}\n\n.project_task_from_label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #333;\n  margin-top: 8px;\n  display: block;\n}\n\n.project_task_from_submit_button {\n  background-color: #007bff;\n  color: white;\n  padding: 10px 14px;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  cursor: pointer;\n  width: 100%;\n}\n\n.project_task_from_submit_button:hover {\n  background-color: #0056b3;\n}\n\n@media (max-width: 768px) {\n  .project_task_from_popup {\n    width: 90%;\n    padding: 20px;\n  }\n\n  .project_task_from_input {\n    font-size: 13px;\n  }\n\n  .project_task_from_submit_button {\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 480px) {\n  .project_task_from_popup {\n    padding: 15px;\n  }\n\n  .project_task_from_input {\n    padding: 8px;\n    font-size: 12.5px;\n  }\n\n  .project_task_from_label {\n    font-size: 13px;\n  }\n\n  .project_task_from_submit_button {\n    font-size: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
